import { render, staticRenderFns } from "./EducationEntryDialog.vue?vue&type=template&id=d2e5d606&"
import script from "./EducationEntryDialog.vue?vue&type=script&lang=js&"
export * from "./EducationEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports